<template>

    <div class="card mb-4" v-show="job.number">

        <h4 class="card-header">
            {{ job.number }} {{job.title}}
        </h4>

        <div class="card-body mb-2">

            <p v-if="job.description" class="card-text">
                <b class="">Description:</b> {{job.description}}
            </p>
            <p v-if="job.location" class="card-text">
                <b>Location:</b> {{job.location}}
            </p>
            <p v-if="job.project_manager" class="card-text mb-3">
                <b>Project Manager:</b> <a :href="'mailto:' + project_manager.email">{{project_manager.first_name}} {{project_manager.last_name}}</a>
            </p>
            <p v-else class="card-text mb-3">
                <b>Project Manager:</b> Not Set
            </p>
            <p v-if="!job.active" class="card-text mb-3">This job is currently inactive</p>
            <!--
            <div v-if="transmittal_data" class="table-responsive-sm">
                <table class="table table-bordered table-sm table-striped">
                    <thead>
                        <tr>
                             <th v-for="col in ts_columns" v-bind:key="col" @click="sortTable(col)" class="sortable">{{col}}
                                <font-awesome-icon class="float-right" v-if="col === sortColumn" v-bind:icon="ascending ? 'arrow-up' : 'arrow-down'"/>
                             </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in transmittal_data" v-bind:key="row[4]">
                            <td v-for="col in ts_columns" v-bind:key="row[col]"> {{ row[col] }} </td>
                        </tr>
                    </tbody>
                    <caption>Transmittal's</caption>

                </table>
            </div>
            -->
            <div v-if="job.remarks" >
                <hr>
                <p class="card-text"><b>Remarks:</b></p>
                <p class="card-text">{{job.remarks}}</p>
            </div>

        </div>

    </div>

</template>

<script>

    import $ from 'jquery';

    export default {
        name: "JobDetail",
        data: function () {
            return {
                ascending: false,
                sortColumn: '',
            }
        },
        computed: {

            project_manager: function () {
                let arr = this.$store.getters.project_manager_list;
                return arr.find((pm) => {
                    return pm.pk === this.job.project_manager
                })
            },

            /*
            "ts_columns": function columns() {
                if (this.transmittal_data.length === 0) {
                    return []
                }
                return Object.keys(this.transmittal_data[0])
            }

             */
        },
        methods: {

            toast(){
                $('#toast-test').toast('show')
            }

            /*
          "sortTable": function sortTable(col) {
              if (this.sortColumn === col) {
                  this.ascending = !this.ascending
              } else {
                  this.ascending = true;
                  this.sortColumn = col
              }

              let ascending = this.ascending;

              this.transmittal_data.sort(function(a, b) {
                  if (a[col] > b[col]) {
                      return ascending ? 1 : -1
                  } else if (a[col] < b[col]) {
                      return ascending ? -1 : 1
                  }
                  return 0;
              })
          },\

             */
        },
        props: ['job']
    }

</script>

<style>

    /*
    th.sortable {
        cursor: pointer;
    }

     */

</style>